import { render, staticRenderFns } from "./whatsapp-button.vue?vue&type=template&id=625dfabe&scoped=true&"
import script from "./whatsapp-button.vue?vue&type=script&lang=js&"
export * from "./whatsapp-button.vue?vue&type=script&lang=js&"
import style0 from "./whatsapp-button.vue?vue&type=style&index=0&id=625dfabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625dfabe",
  null
  
)

export default component.exports